import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbModule } from '@cmps/ng-bootstrap';
import {
    CmpsActivityStatusWrapperModule,
    CmpsFocusItemModule,
} from '@cmps/ng-kit';
import {
    CmpsAccordionModule,
    CmpsButtonModule,
    CmpsChipModule,
    CmpsFilterModule,
    CmpsIconModule,
    CmpsMenuModule,
    CmpsPortalModule,
    CmpsScrollbarModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { TranscriptService } from '../../../../coaching-base/transcript.service';
import { CmpsCommonModule } from '../../../../common/common.module';
import { CmpsDateRangeModule } from '../../../../common/component/date-range';
import { CmpsLazyI18nModule } from '../../../../i18n/i18n.module';
import { epicObs } from '../../../../store';
import {
    CmpsTeamsCallModule,
    CmpsTeamsCallTranscriptImportDialogModule,
} from '../../../../teams-call';

import { CmpsTooltipConditionalModule } from './tooltip-conditional.module';
import { TranscriptSummaryComponent } from './transcript-summary.component';
import { transcriptSummaryEpics } from './transcript-summary.epic';
import { TranslationIdMap } from './transcript-summary.i18n';

@NgModule({
    declarations: [TranscriptSummaryComponent],
    exports: [TranscriptSummaryComponent],
    imports: [
        CmpsAccordionModule,
        CmpsActivityStatusWrapperModule,
        CmpsButtonModule,
        CmpsCommonModule,
        CmpsChipModule,
        CmpsDateRangeModule,
        CmpsFilterModule,
        CmpsFocusItemModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsMenuModule,
        CmpsPortalModule,
        CmpsScrollbarModule,
        CmpsTeamsCallModule,
        CmpsTeamsCallTranscriptImportDialogModule,
        CmpsTooltipConditionalModule,
        CmpsTooltipModule,
        CommonModule,
        FormsModule,
        NgbModule,
        NgbDatepickerModule,
    ],
    providers: [TranscriptService],
})
export class CmpsCoachingTranscriptSummaryModule {
    constructor() {
        transcriptSummaryEpics.forEach((e) => epicObs.next(e));
    }
}
